module.exports = __webpack_public_path__ + "media/images/book-dedeeb5f0fa2ee2e0292bba9a2198707.svg";